<template>
	<form @submit.prevent="onSubmit">
		<JBox class="s-p-8">
			<CFormInput componentName="JInputText" v-model="$v.form.name.$model" name="name" :label="$t('products.name')" />

			<JBox class="s-text-red-500" v-if="!$v.form.name.required && $v.form.name.$dirty">
				{{ $t("products.required") }}
			</JBox>

			<CFormInput
				:componentName="CInsurerPicker"
				v-model="form.insurerId"
				name="insurerId"
				:label="$t('products.insurer')"
				class="s-mt-6"
			/>

			<!-- Buttons -->
			<JFlex class="s-w-full s-justify-between s-mt-6">
				<JButton variant="default-light" type="submit">{{ $t("products.save") }}</JButton>
				<JButton variant="white" @click="$emit('cancel')">{{ $t("products.cancel") }}</JButton>
			</JFlex>
		</JBox>
	</form>
</template>

<script>
import { required } from "vuelidate/lib/validators"
import CInsurerPicker from "@/modules/core/components/CInsurerPicker"

export default {
	data() {
		return {
			form: {
				name: null,
				insurerId: null,
			},

			CInsurerPicker,
		}
	},

	validations: {
		form: {
			name: { required },
		},
	},

	computed: {
		locale() {
			return this.$store.state?.products?.detail?.locale
		},

		product() {
			return this.$store.state?.products?.detail?.product ?? {}
		},
	},

	methods: {
		async onSubmit() {
			this.$v.$touch()
			if (this.$v.$invalid) return

			this.$emit("save", this.form)
		},
	},

	watch: {
		product: {
			handler() {
				this.form.name = this.product.name
				this.form.insurerId = this?.product?.insurer?.id
			},
			immediate: true,
			deep: true,
		},
	},
}
</script>
